import { Box, Typography } from "@mui/material";
import { WfHeader, WfMenuList, WfMenuListItem } from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";
import { formatDuration } from "@WahooFitness/unit-convertr-ts";

type KnownTimesSectionProps = {
  knownTimes: Array<{ time: number | null | undefined; distance: string }>;
};

const emptyTimeDisplay = (
  <Typography variant="prose-base-medium" color="text.disabled">
    --:--
  </Typography>
);

const KnownTimesSection = ({ knownTimes }: KnownTimesSectionProps) => {
  return (
    <Box width="100%">
      <WfHeader title={t`Known recent times`} hierarchy="H2" />
      <Box
        width="100%"
        display="grid"
        columnGap={1}
        sx={{
          gridTemplateRows: "repeat(2, fit-content(100%))",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        }}
        px={2}
      >
        {knownTimes.map((item, index) => {
          const timeDisplay =
            item.time !== null && item.time !== undefined
              ? formatDuration(item.time, "full")
              : emptyTimeDisplay;
          return (
            <WfMenuList key={index} variant="outlined" disableGutters>
              <WfMenuListItem
                id={`recent-time-${index}`}
                isKeyValue
                content={item.distance}
                secondaryContent={timeDisplay}
              />
            </WfMenuList>
          );
        })}
      </Box>
    </Box>
  );
};

export default KnownTimesSection;
